import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import classNames from 'classnames'

import TournamentsList from './components/TournamentsList/TournamentsList'
import EventsList from './components/EventsList/EventsList'

import styles from './styles.module.scss'

const TABS = {
  events: 'events',
  tournaments: 'tournaments',
}

const CommunityFooter = () => {
  const { tab, communityId } = useParams()
  const [currentTab, setCurrentTab] = useState(tab)

  const getTabClassName = (tabName) => {
    return classNames(styles.tab, {
      [styles.active]: currentTab === tabName
    })
  }

  return (
    <section
      className={styles.events__tournaments}
      data-testid='community-footer'
    >
      <div className={styles.tab__wrapper} data-testid='community-tabs'>
        <h3
          className={getTabClassName(TABS.events)}
          onClick={() => setCurrentTab(TABS.events)}
          data-testid='community-events-tab'
        >
          <FormattedMessage id='calendar.events' />
        </h3>

        <h3
          className={getTabClassName(TABS.tournaments)}
          onClick={() => setCurrentTab(TABS.tournaments)}
          data-testid='community-tournaments-tab'
        >
          <FormattedMessage id='calendar.tournaments' />
        </h3>
      </div>
      
      {currentTab === TABS.events && <EventsList communityId={communityId} />}
      {currentTab === TABS.tournaments && <TournamentsList communityId={communityId} />}
    </section>
  )
}

export default CommunityFooter
